var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"employee-profile-page employee-profile-page--detail"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('Card',{attrs:{"card-class":'employee-profile-card employee-profile-card--detail'},scopedSlots:_vm._u([{key:"body",fn:function(){return [_c('HrDetail',{attrs:{"data":_vm.data}})]},proxy:true}])})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }